export class Item {
    constructor(item) {
        this.nutritional_information = item.nutritional_information;
        this.id = item.id;
        this.name = item.name;
        this.description = item.description;
        this.image = item.image;
        this.category_id = item.category_id;
        this.note = item.note;
        this.type = item.type;
        this.visibility = item.visibility;
        this.prepare_duration = item.prepare_duration;
        this.slug = item.slug;
        this.modifier = item.modifier ? this.getItemModifier(item.modifier) : [];
        this.created_at = item.created_at;
        this.updated_at = item.updated_at;
        this.sku = item.sku;
        this.status = item.status;
        this.item_variants = item.item_variants ? this.getVariantList(item.item_variants) : [];
        this.instock_status = item.status == 1 ? 1 : 0;
        // this.item_variants = item.item_variants;
    }

    getItemModifier(item_modifier) {
        let arr = [];
        for(let i = 0; i < item_modifier.length; i++) {
            arr.push(new Modifier(item_modifier[i]));
        }
        return arr;
    }

    getVariantList(list) {
        let arr = [];
        for(let i = 0; i < list.length; i++) {
            arr.push(new Variant(list[i]));
        }
        return arr;
    }
}

class Variant {
    constructor(variant) {
        this.id = variant.id;
        this.item_id = variant.item_id;
        this.image = variant.image;
        this.name = variant.name;
        this.description = variant.description;
        this.price = variant.price;
        this.status = variant.status;
        this.created_at = variant.created_at;
        this.updated_at = variant.updated_at;
    }
}

class Modifier {
    constructor(modifier) {
        this.is_selected = modifier.is_selected != undefined && modifier.is_selected != null ? modifier.is_selected : false;
        this.modifier_name = modifier.modifier_name;
        this.title = modifier.modifier_name;
        this.type = modifier.type;
        this.required = modifier.required;
        this.details = modifier.details ? this.getDetailList(modifier.details) : [];
        this.id = modifier.id;
    }

    getDetailList(detail) {
        let arr = [];
        for(let i = 0; i < detail.length; i++) {
            arr.push(new ModifierOption(detail[i]));
        }
        return arr;
    }

    changeStatusSelected() {
        this.is_selected = !this.is_selected;
    }

    changeStatusFalse() {
        this.is_selected = false;
    }

    changeStatusTrue() {
        this.is_selected = true;
    }
}

class ModifierOption {
    constructor(option) {
        this.id = option.id;
        this.name = option.name;
        this.price = option.price;
    }
}
